import assetActionTypeService from "../../../../services/assetService/assetActionService/assetActionTypeService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETACTIONTYPES } from "../../../../utils/constants";
import { AssetActionTypeInterface } from "../../../../models/AssetModel/AssetAction/AssetActionType";

const useAssetActionTypes = (page: number, pageSize: number) =>
  useQuery<AssetActionTypeInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETACTIONTYPES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => assetActionTypeService.GetAll(page, pageSize),
    initialData: [],
  });

export default useAssetActionTypes;
